import React from "react";
import NotificationBar from "./NotificationBar";

/**
 * Notifications component to display notification messages
 * @param {Object} props - Component props
 * @param {string} props.notification - Notification message
 * @param {string} props.notificationType - Type of notification
 * @param {Function} props.onClear - Clear notification handler
 * @returns {JSX.Element|null} The notifications component
 */
const Notifications = ({
  notification,
  notificationType = "info",
  onClear,
}) => {
  if (!notification) {
    return null;
  }

  return (
    <NotificationBar
      message={notification}
      type={notificationType}
      onClose={onClear}
    />
  );
};

export default Notifications;
